import { render, staticRenderFns } from "./PreguntasFrecuentesEditor.vue?vue&type=template&id=03a4fdb6&scoped=true&"
import script from "./PreguntasFrecuentesEditor.vue?vue&type=script&lang=js&"
export * from "./PreguntasFrecuentesEditor.vue?vue&type=script&lang=js&"
import style0 from "./PreguntasFrecuentesEditor.vue?vue&type=style&index=0&id=03a4fdb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4fdb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDivider,VIcon,VRow,VSelect,VSpacer,VTextField,VTextarea})
